import {
  browserName,
  fullBrowserVersion,
  osName,
  osVersion,
} from "react-device-detect";

import { version } from "../../package.json";

const PROJECT_KEY = "UF";

export enum FeedbackType {
  feedback = "Feedback",
  error = "Error",
  design = "Design",
  userRequest = "User request",
  other = "Other",
}

export type TValues = {
  type: FeedbackType;
  message: string;
  files: [] | Array<File>;
  email: string;
  uid: string;
  displayName?: string;
};

export const makeReportIssue = ({ uid, type, email, message, files }: TValues) => {
  const body = new FormData();
  const data = {
    projectKey: PROJECT_KEY,
    type,
    email,
    version,
    message,
    environment: [
      { title: "User Id", value: uid },
      { title: "Environment", value: process.env.NODE_ENV },
      { title: "Operation System Name", value: osName },
      { title: "Operation System Version", value: osVersion },
      { title: "Browser", value: browserName },
      { title: "Browser version", value: fullBrowserVersion },
      { title: "web-app version", value: version },
    ],
    labels: ["debug", "web-app.beta"],
  };

  body.append("data", JSON.stringify(data));

  files.forEach((file) => {
    body.append(file.name, file);
  });

  return fetch(
    `${process.env.REACT_APP_FIREBASE_FUNCTION_URL}/createJiraTicket`,
    { method: "POST", body }
  ).then(res => res.json());
};
